
const en = {
  // Common
  common: {
    learnMore: 'Learn More',
    getStarted: 'Get Started',
  },

  // Navigation
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    solutions: 'Solutions',
    blog: 'Blog',
    contact: 'Contact',
    getStarted: 'Get Started',
    login: 'Login',
  },

  // Home Page
  home: {
    hero: {
      badge: 'Digital Innovation Leader',
      title: 'Digital Solutions',
      subtitle: 'We transform your ideas into powerful digital solutions. Custom software development, web and mobile applications, and IT consulting services in Lubumbashi.',
      cta: 'Get Started',
      learnMore: 'Learn More',
      stat1: 'Projects Success',
      stat2: 'Satisfaction Rate',
      stat3: 'Years of Experience',
      card1Title: 'Custom Development',
      card1Desc: 'Tailored solutions for your needs',
      card2Title: 'Secure & Reliable',
      card2Desc: '99.9% uptime guaranteed',
    },
    trust: {
      title: 'Trusted by Leading Businesses',
      partners: 'Technology Partners',
      certifications: 'Certifications',
      satisfaction: 'Client Satisfaction',
      stats: {
        clients: 'Happy Clients',
        projects: 'Projects Completed',
        satisfaction: 'Client Satisfaction',
        experience: 'Years of Experience',
      },
    },
    value: {
      title: 'Why Choose',
      titleHighlight: 'LogiqSoft',
      description: 'We deliver innovative digital solutions that drive business growth and operational excellence',
      established: 'Established Since',
      satisfactionRate: 'Client Satisfaction Rate',
      standards: 'International Standards',
      isoCompliant: 'ISO Compliant',
      features: {
        expertise: {
          title: 'Technical Expertise',
          description: 'Our team of experienced developers and consultants brings deep technical knowledge across multiple platforms and technologies.',
        },
        quality: {
          title: 'Quality Assurance',
          description: 'We follow industry best practices and rigorous testing procedures to ensure reliable, high-performance solutions.',
        },
        support: {
          title: 'Dedicated Support',
          description: '24/7 technical support and maintenance services to keep your systems running smoothly at all times.',
        },
        innovation: {
          title: 'Innovation Focus',
          description: 'We stay ahead of technology trends to deliver cutting-edge solutions that give you a competitive advantage.',
        },
      },
    },
    services: {
      title: 'Our',
      titleHighlight: 'Services',
      description: 'Comprehensive digital solutions tailored to your business needs',
      subtitle: 'Comprehensive digital solutions tailored to your business needs',
      custom: 'Custom Software',
      customDesc: 'Tailored software solutions designed to solve your unique business challenges and streamline operations.',
      customFeatures: {
        webApps: 'Custom Web Apps',
        mobile: 'Mobile Solutions',
        desktop: 'Desktop Software',
        api: 'API Integration',
      },
      cloud: 'IT Support & Cloud',
      cloudDesc: 'Keep your systems running smoothly with our comprehensive IT support and cloud infrastructure services.',
      cloudFeatures: {
        monitoring: '24/7 Monitoring',
        network: 'Network Management',
        cloud: 'Cloud Solutions',
        security: 'Security Services',
      },
      mobile: 'Digital Marketing',
      mobileDesc: 'Boost your brand visibility and drive conversions with our data-driven digital marketing strategies.',
      mobileFeatures: {
        seo: 'SEO Optimization',
        social: 'Social Media',
        content: 'Content Strategy',
        analytics: 'Analytics & Reporting',
      },
      items: {
        webDev: {
          title: 'Web Development',
          description: 'Custom websites and web applications built with modern technologies for optimal performance and exceptional user experience.',
        },
        mobileDev: {
          title: 'Mobile Development',
          description: 'Native and cross-platform mobile applications for iOS and Android that engage users and drive business results.',
        },
        software: {
          title: 'Custom Software',
          description: 'Tailored software solutions designed to solve your unique business challenges and streamline operations.',
        },
        cloud: {
          title: 'Cloud Solutions',
          description: 'Scalable cloud infrastructure and migration services to enhance flexibility and reduce IT costs.',
        },
        iot: {
          title: 'IoT Solutions',
          description: 'Internet of Things implementations for smart automation, monitoring, and data-driven decision making.',
        },
        consulting: {
          title: 'IT Consulting',
          description: 'Strategic technology consulting to help you make informed decisions and optimize your IT investments.',
        },
      },
    },
    process: {
      title: 'How We',
      titleHighlight: 'Work',
      description: 'Our proven process ensures successful project delivery from concept to launch',
      steps: {
        strategy: {
          title: 'Strategy Workshop',
          description: 'We recommend solution features and digital strategies that help you achieve your business goals.',
        },
        wireframes: {
          title: 'Wireframes',
          description: 'We break down the layers of "user-friendly" features to refine the core value proposition of your solution.',
        },
        prototyping: {
          title: 'Prototyping',
          description: 'We rapidly develop solution features that you can experiment with and validate.',
        },
        development: {
          title: 'Development',
          description: 'We use a design-driven development process to define every screen and feature of the solution.',
        },
      },
      delivery: 'Average project delivery: 4-8 weeks',
    },
    caseStudies: {
      title: 'Success',
      titleHighlight: 'Stories',
      description: 'Real results from real projects that made a difference',
      items: {
        irrigation: {
          title: 'Automatic Irrigation System',
          category: 'Environment & Agriculture',
          description: 'Development of an IoT-based automatic irrigation system that reduced water consumption by 40% while improving crop yields for agricultural clients.',
          results: ['40% Water Savings', '25% Yield Increase', 'Real-time Monitoring'],
          tech: ['IoT', 'Cloud Computing', 'Mobile App'],
        },
        tracking: {
          title: 'Vehicle Tracking Software',
          category: 'Transport & Logistics',
          description: 'Built a comprehensive vehicle tracking solution showcased at FEC, enabling real-time fleet management and route optimization for transport companies.',
          results: ['30% Cost Reduction', 'Real-time GPS', '99.9% Uptime'],
          tech: ['GPS Integration', 'Web Dashboard', 'Mobile Apps'],
        },
        erp: {
          title: 'Enterprise Resource Planning',
          category: 'Business Management',
          description: 'Implemented a custom ERP system for a manufacturing company, streamlining operations from inventory to sales and improving efficiency.',
          results: ['50% Time Savings', 'Unified Platform', 'Better Insights'],
          tech: ['Custom Software', 'Database Design', 'API Integration'],
        },
      },
      keyResults: 'Key Results',
      techUsed: 'Technologies Used',
    },
    testimonials: {
      title: 'Client',
      titleHighlight: 'Testimonials',
      description: 'Hear what our clients say about working with us',
      items: {
        testimonial1: {
          quote: 'LogiqSoft transformed our operations with their custom ERP solution. The efficiency gains have been remarkable, and their support team is always there when we need them.',
          name: 'Jean-Pierre Mukendi',
          role: 'CEO, Mining Solutions Ltd',
          company: 'Lubumbashi',
        },
        testimonial2: {
          quote: 'The vehicle tracking system they developed has revolutionized our fleet management. Real-time monitoring and route optimization have cut our costs by 30%.',
          name: 'Marie Kabamba',
          role: 'Operations Director',
          company: 'Transport & Logistics Co',
        },
        testimonial3: {
          quote: 'Their IoT irrigation solution exceeded our expectations. The system is reliable, easy to use, and has significantly improved our water management efficiency.',
          name: 'David Mwamba',
          role: 'IT Manager',
          company: 'Agricultural Services',
        },
        testimonial4: {
          quote: 'LogiqSoft\'s digital marketing services have significantly increased our online presence. Their strategic approach and attention to detail are exceptional.',
          name: 'Sophie Kalala',
          role: 'Marketing Director',
          company: 'Retail Group',
        },
      },
      stats: {
        clients: 'Happy Clients',
        rating: 'Average Rating',
        retention: 'Client Retention',
      },
    },
    cta: {
      title: 'Ready to Transform Your Business?',
      description: 'Let\'s discuss how our digital solutions can help you achieve your goals. Get a free consultation and project estimate today.',
      features: {
        response: 'Fast Response',
        secure: 'Secure & Reliable',
        support: '24/7 Support',
      },
      startProject: 'Start Your Project',
      callUs: 'Call Us Now',
    },
  },

  // About Page
  about: {
    title: 'About',
    titleHighlight: 'LogiqSoft',
    subtitle: 'Empowering businesses with innovative digital solutions since 2019',
    story: {
      title: 'Our Story',
      paragraph1: 'LogiqSoft SARL was founded in 2019 with a clear mission: to deliver the highest quality services and solutions to our clients. Based in Lubumbashi and Kolwezi, we\'ve grown into a strong and effective team of digital experts.',
      paragraph2: 'We are deeply committed to contributing significantly and positively to the design, improvement, and maintenance of your digital management, communication, production, and security solutions.',
      paragraph3: 'Our expertise and design and development methods form the foundation of our digital strategy. You can always be sure to get up-to-date digital solutions that meet your expectations and fulfill your innovation requirements to make a difference against the competition.',
      paragraph4: 'We are motivated and passionate about new technologies and how they can solve your business challenges.',
    },
    values: {
      title: 'Our Core Values',
      subtitle: 'The principles that guide everything we do',
      innovation: {
        title: 'Innovation',
        description: 'We stay ahead of technology trends to deliver cutting-edge solutions.',
      },
      collaboration: {
        title: 'Collaboration',
        description: 'We work closely with clients to understand and exceed their expectations.',
      },
      excellence: {
        title: 'Excellence',
        description: 'We maintain the highest standards in everything we deliver.',
      },
      integrity: {
        title: 'Integrity',
        description: 'We build trust through transparency and honest communication.',
      },
    },
    team: {
      title: 'Our',
      titleHighlight: 'Team',
      subtitle: 'Meet the passionate professionals behind LogiqSoft',
    },
    cta: {
      title: 'Ready to Work Together?',
      description: 'Let\'s discuss how we can help transform your business with our digital solutions.',
      button: 'Get in Touch',
    },
  },

  // Services Page
  services: {
    title: 'Our',
    titleHighlight: 'Services',
    subtitle: 'Comprehensive IT solutions tailored to transform your business and drive digital innovation',
    getStarted: 'Get Started',
    ctaTitle: 'Ready to Transform Your Business?',
    ctaDescription: 'Let\'s discuss how our services can help you achieve your digital goals',
    ctaButton: 'Schedule a Consultation',
    softwareDev: {
      title: 'Software Development',
      tagline: 'Custom Software Solutions for Your Business',
      description: 'We create powerful, scalable software solutions tailored to your unique business needs. From web applications to mobile apps, our expert team delivers high-quality code that drives results.',
      features: {
        title: 'Key Features',
        items: [
          'Custom Web Applications',
          'Mobile App Development (iOS & Android)',
          'API Development & Integration',
          'Cloud-Native Solutions',
          'Microservices Architecture',
          'DevOps (CI/CD)',
        ],
      },
      benefits: {
        title: 'Key Benefits',
        performance: { title: 'High Performance', desc: 'Optimized code and architecture for lightning-fast applications' },
        secure: { title: 'Secure & Reliable', desc: 'Enterprise-grade security and 99.9% uptime guarantee' },
        responsive: { title: 'Fully Responsive', desc: 'Seamless experience across all devices and platforms' },
      },
      techTitle: 'Technologies We Use',
    },
    itSupport: {
      title: 'IT Support & Maintenance',
      tagline: '24/7 Technical Support for Your Peace of Mind',
      description: 'Keep your systems running smoothly with our comprehensive IT support services. Our dedicated team provides proactive monitoring, rapid issue resolution, and ongoing maintenance.',
      features: {
        title: 'Key Features',
        items: [
          '24/7 Help Desk Support',
          'Proactive System Monitoring',
          'Network Management',
          'Security Updates & Patches',
          'Data Backup & Recovery',
          'Hardware & Software Maintenance',
        ],
      },
      benefits: {
        title: 'Key Benefits',
        availability: { title: '24/7 Availability', desc: 'Round-the-clock support whenever you need assistance' },
        monitoring: { title: 'Proactive Monitoring', desc: 'Identify and resolve issues before they impact your business' },
        team: { title: 'Expert Team', desc: 'Certified professionals with years of experience' },
      },
      techTitle: 'Technologies We Support',
    },
    digitalMarketing: {
      title: 'Digital Marketing',
      tagline: 'Grow Your Online Presence & Reach More Customers',
      description: 'Boost your brand visibility and drive conversions with our data-driven digital marketing strategies. From SEO to social media, we help you connect with your target audience.',
      features: {
        title: 'Key Features',
        items: [
          'Search Engine Optimization (SEO)',
          'Social Media Marketing',
          'Content Marketing',
          'Email Marketing Campaigns',
          'Pay-Per-Click (PPC) Advertising',
          'Analytics & Reporting',
        ],
      },
      benefits: {
        title: 'Key Benefits',
        visibility: { title: 'Increased Visibility', desc: 'Rank higher in search results and reach more customers' },
        leads: { title: 'More Leads', desc: 'Convert visitors into customers with targeted campaigns' },
        data: { title: 'Data-Driven', desc: 'Make informed decisions based on real-time analytics' },
      },
      techTitle: 'Tools We Use',
    },
    whyChoose: {
      title: 'Why Choose',
      titleHighlight: 'LogiqSoft?',
      description: 'We offer specialized automated solutions that meet international standards, helping businesses transform digitally with cutting-edge technology.',
      mobility: { title: 'Enterprise Mobility', description: 'Comprehensive mobile solutions for modern enterprises, enabling seamless business operations on the go.' },
      iot: { title: 'IoT Development', description: 'Connect and automate your devices with our advanced Internet of Things solutions.' },
      desktop: { title: 'Desktop Software', description: 'Powerful desktop applications built with modern frameworks for maximum performance.' },
      mobileWeb: { title: 'Mobile & Web Development', description: 'Responsive web and mobile applications that deliver exceptional user experiences.' },
    },
  },

  // Solutions Page
  solutions: {
    title: 'Innovative',
    titleHighlight: 'Solutions',
    subtitle: 'Cutting-edge technology solutions designed to solve complex business challenges and drive growth',
    keyFeatures: 'Key Features',
    industries: 'Industries',
    ctaTitle: 'Ready to Implement a Solution?',
    ctaDescription: 'Let\'s discuss how our solutions can address your specific business challenges',
    ctaButton: 'Get Started Today',
    items: {
      mobility: {
        title: 'Enterprise Mobility Solutions',
        description: 'Empower your workforce with mobile-first solutions that enable productivity anywhere, anytime.',
        features: ['Mobile Device Management','Enterprise App Development','BYOD Solutions','Mobile Security','Cross-Platform Apps','Offline Capabilities'],
        industries: ['Healthcare','Retail','Finance','Logistics','Manufacturing'],
      },
      iot: {
        title: 'IoT Development',
        description: 'Connect your devices and unlock new possibilities with our IoT solutions.',
        features: ['Device Integration','Real-time Monitoring','Data Analytics','Cloud Connectivity','Edge Computing','Predictive Maintenance'],
        industries: ['Smart Cities','Agriculture','Energy','Transportation','Healthcare'],
      },
      desktop: {
        title: 'Desktop Software Solutions',
        description: 'Powerful desktop applications built for performance and reliability.',
        features: ['Native Performance','Offline Functionality','Advanced UI/UX','System Integration','Multi-platform Support','Enterprise Features'],
        industries: ['Finance','Engineering','Design','Education','Healthcare'],
      },
      mobileWeb: {
        title: 'Mobile & Web Development',
        description: 'Create engaging digital experiences with our mobile and web development services.',
        features: ['Responsive Design','Progressive Web Apps','Native Mobile Apps','API Integration','Real-time Features','Cloud Deployment'],
        industries: ['E-commerce','Media','Education','Travel','Entertainment'],
      },
    },
    process: {
      title: 'Our Implementation Process',
      subtitle: 'A proven methodology to deliver successful solutions',
      steps: {
        discovery: { title: 'Discovery', description: 'We analyze your needs and define project requirements' },
        design: { title: 'Design', description: 'Create user-centric designs and technical architecture' },
        development: { title: 'Development', description: 'Build and test your solution with agile methodology' },
        deployment: { title: 'Deployment', description: 'Launch and provide ongoing support and maintenance' },
      },
    },
  },

  // Blog Page
  blog: {
    title: 'Our',
    titleHighlight: 'Blog',
    subtitle: 'Insights, updates, and thought leadership on digital transformation and technology',
    categories: {
      all: 'All',
      technology: 'Technology',
      business: 'Business',
      development: 'Development',
      security: 'Security',
      cloud: 'Cloud',
      marketing: 'Marketing',
    },
    readMore: 'Read More',
    loadMore: 'Load More Articles',
    newsletter: {
      title: 'Subscribe to Our Newsletter',
      description: 'Get the latest insights and updates delivered to your inbox',
      placeholder: 'Enter your email',
      button: 'Subscribe',
      consent: 'I agree to receive emails',
      success: 'Thanks for subscribing!',
      error: 'Unable to subscribe. Please try again.',
    },
  },

  // Contact Page
  contact: {
    title: 'Get in',
    titleHighlight: 'Touch',
    subtitle: 'Let\'s discuss how we can help transform your business with our digital solutions',
    info: {
      locations: { title: 'Our Locations', lubumbashi: 'Lubumbashi, DR Congo', kolwezi: 'Kolwezi, DR Congo' },
      email: { title: 'Email Us' },
      phone: { title: 'Call Us' },
    },
    form: {
      title: 'Send Us a Message',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      company: 'Company Name',
      service: 'Service Interested In',
      selectService: 'Select a service',
      message: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      characters: 'characters',
      required: '*',
      sending: 'Sending...',
      send: 'Send Message',
      success: 'Thank you! Your message has been sent successfully.',
      error: 'Something went wrong. Please try again.',
    },
    services: ['Software Development','IT Support','Digital Marketing','Mobile App Development','IoT Solutions','Cloud Services','Other'],
    visit: {
      title: 'Visit Our Office',
      description: 'We\'re located in Lubumbashi and Kolwezi. Feel free to visit us or schedule a meeting.',
    },
    hours: {
      title: 'Business Hours',
      weekdays: 'Monday - Friday',
      weekdaysTime: '8:00 AM - 6:00 PM',
      saturday: 'Saturday',
      saturdayTime: '9:00 AM - 2:00 PM',
      sunday: 'Sunday',
      sundayTime: 'Closed',
    },
  },

  // Footer
  footer: {
    description: 'Leading digital solutions provider in Lubumbashi, specializing in custom software development, web & mobile applications, and IT consulting services.',
    quickLinks: 'Quick Links',
    services: 'Services',
    contact: 'Contact Us',
    followUs: 'Follow Us',
    rights: 'All rights reserved.',
  },
};

export default en;
